import { StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayStats, StatisticalAnalysisDelayAndResponseTimesDossierResponseContentTimeStats } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.dto'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { StatisticalAnalysisTemporalFilterEnum, StatisticalAnalysisTemporalFilterOptions } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisEnumsAndKeys } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticalAnalysisDelaysAndResponseTimeGeneralComboItems {
    id: string
    text: string
}

export interface StatisticalAnalysisDelaysAndResponseTimeGeneralSelectionDetail {
    timeFilter: StatisticalAnalysisTemporalFilterOptions
    trackingItems: StatisticalInfoPaginatorTrackingItems[]
    itemSelected: StatisticalInfoPaginatorTrackingItems
    delayType: StatisticalAnalysisDelaysAndResponseTimeGeneralComboItems
}

export interface StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelector {
    selected: StatisticalAnalysisDelaysAndResponseTimeGeneralComboItems
    list: StatisticalAnalysisDelaysAndResponseTimeGeneralComboItems[],
}

export const StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorCombo: StatisticalAnalysisDelaysAndResponseTimeGeneralComboItems[] = [
    StatisticalAnalysisEnumsAndKeys.COMPLETED.getModel(),
    StatisticalAnalysisEnumsAndKeys.DELAYED.getModel()
]

export interface StatisticalAnalysisDelaysAndResponseTimeGeneralState {
    temporalFilter: StatisticalAnalysisTemporalFilterOptions
    responseTimeSelector: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelector
    trackingItems: (StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayStats[] | StatisticalAnalysisDelayAndResponseTimesDossierResponseContentTimeStats[])
    promiseViewTracking: Nullable<Promise<void>>
}
export const initialStatisticalAnalysisDelaysAndResponseTimeGeneralState =
    (): StatisticalAnalysisDelaysAndResponseTimeGeneralState => ({
        temporalFilter: {
            id: StatisticalAnalysisTemporalFilterEnum.DAYS,
            text: 'statisticalAnalysis.times.days'
        },
        responseTimeSelector: {
            selected: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorCombo[0],
            list: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorCombo
        },
        trackingItems: [],
        promiseViewTracking: null
    })
